export default (state = null,action) => {
    switch(action.type){
      case 'SET_ID':
        return action.payload
      default:
        return state
    }
  }
  